import * as React from 'react';
import type { SVGProps } from 'react';
const FileUnknown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#prefix__a)">
      <path
        fill="#BCC0D1"
        fillRule="evenodd"
        d="M2.88 0A2.88 2.88 0 0 0 0 2.88v18.24A2.88 2.88 0 0 0 2.88 24h18.24A2.88 2.88 0 0 0 24 21.12V2.88A2.88 2.88 0 0 0 21.12 0zm8.499 13.656q.198.12.647.119.448 0 .646-.106a.48.48 0 0 0 .251-.29 1.4 1.4 0 0 0 .053-.396v-.384q.122-.038.29-.105.238-.105.515-.277.29-.184.541-.462.252-.29.41-.7.158-.408.158-.95 0-.806-.383-1.425a2.7 2.7 0 0 0-1.03-.99q-.66-.37-1.517-.37-.607 0-1.056.158-.45.159-.766.41a2.55 2.55 0 0 0-.805.976q-.106.212-.132.317a1.6 1.6 0 0 0-.08.515q.014.198.185.343.172.132.542.277.342.133.554.106a.53.53 0 0 0 .343-.224q.145-.185.251-.502a.9.9 0 0 1 .185-.264.9.9 0 0 1 .317-.198 1.2 1.2 0 0 1 .462-.08q.567 0 .845.252.276.237.277.739 0 .343-.146.541-.145.198-.37.33a6 6 0 0 1-.474.224 3 3 0 0 0-.476.251q-.224.132-.37.357-.144.21-.144.58v.476q0 .224.04.422a.6.6 0 0 0 .237.33m-.238 2.878q.211.25.858.25.541 0 .766-.158a.63.63 0 0 0 .277-.41q.053-.25.053-.5 0-.595-.211-.832-.198-.251-.872-.251-.54 0-.765.158a.65.65 0 0 0-.277.41q-.04.25-.04.501 0 .58.211.832"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="prefix__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default FileUnknown;

